export default "__VITE_ASSET__XYM9t08a__"